import React from 'react'
import PropTypes from 'prop-types'

import api from 'services/pet-notify-api'

import InvitationDeclinedScreen from 'ContactApp/screens/Invitation/Declined'

class InvitationDeclinedScreenContainer extends React.PureComponent {
  static propTypes = {
    match: PropTypes.shape({
      params: PropTypes.shape({
        token: PropTypes.string,
      }),
    }),
  }

  state = {
    isLoading: true,
    error: '',
  }

  async componentDidMount() {
    const { match } = this.props
    const { params } = match
    const { token } = params

    try {
      const { user } = await api.contactInvitations.view(token)
      this.setState({ isLoading: false, user })
    } catch (error) {
      this.setState({ isLoading: false, error })
    }
  }

  generateProps = () => ({
    ...this.props,
    ...this.state,
  })

  render() {
    const props = this.generateProps()

    return <InvitationDeclinedScreen {...props} />
  }
}

export default InvitationDeclinedScreenContainer
